import { faker } from '@faker-js/faker';
import { StudioService } from '../studio.interface';
import { Route } from '@/model/route.model';
import { Location } from '@/model/location.model';

export class StudioServiceMock implements StudioService {
    

    public async getRouters(): Promise<Route[]> {
        return new Promise(async (resolve) => {
            const routes: Route[] = [];
            const random = faker.number.int({ min: 1, max: 16 });
            for (let i = 0; i < random; i++) {
                const locations = this.getLocations();
                routes.push({
                    name: faker.location.street(),
                    image: "https://picsum.photos/300/200",
                    description: faker.hacker.phrase(),
                    url: `https://player.onirix.com/projects/823f88d2ecda422aa82c789f5a1fc9c9/` +
                    `webar?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjYyMCwicHJvamVjdEl` +
                    `kIjoyODIwLCJyb2xlIjozLCJpYXQiOjE3MzAzNjQzNjF9.Aghw-8nGAcqhJthkdmtH0GhUih61hq4HjuV` +
                    `M_TiwFe8&background=alpha&preview=false&hide_controls=false&ar_button=false`,
                    locations: locations,
                    address: faker.location.streetAddress(),
                    map: "https://picsum.photos/300/200",
                    description_district: faker.hacker.phrase(),
                    ref: i,
                    directions: faker.location.direction(),
                    token: ""
                });
            }
            resolve(routes);
        });
    }
    
    private getLocations(): Location[] {
        const random = faker.number.int({ min: 1, max: 10 });
        const locations: Location[] = [];
        for (let i = 0; i < random; i++) {
            locations.push({
                oid: "55cab18c18e14aaa8e6289688655898c",
                name: faker.hacker.noun(),
                ar: /*faker.datatype.boolean()*/ false,
                description: faker.hacker.phrase(),
                image: "https://picsum.photos/200/300",
                long: faker.location.longitude(),
                lat: faker.location.latitude(),
                address: faker.location.streetAddress(),
                quiz: faker.datatype.boolean(),
                image_ant: "https://picsum.photos/200/300",
                author: faker.person.firstName(),
                author_ant: faker.person.firstName()
            });
        }
        return locations;
    }

    public getImage(oid: string): string {
        // TODO
        return "";
    }

    addNewView(oid: string, token: string): void {
        console.log("New view added to scene", oid);
    }

}